module.exports = __webpack_public_path__ + "static/img/dd-customer-09.c76c624.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/dd-customer-09.jpg
// module id = 5ePj
// module chunks = 1